<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px',marginLeft:'10px' }"
        @click="editAndAdd"
      >
        新增企业
      </a-button>
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="addEditArea"
      >
        新增大区账户
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />

          <popconfirm-button
            v-if=" record.fdd_exist_sign === 0"
            text="签章"
            alert-title="确定签章？"
            @onDelete="() => handleSignature(record)"
          />
          <a-divider
            v-if=" record.fdd_exist_sign === 0"
            type="vertical"
          />
          <popconfirm-button
            v-if=" record.fdd_exist_sign === 1"
            :text="record.status === 0 ? '启用' : '禁用'"
            :alert-title="record.status === 0 ? '确定启用？' : '确定禁用？'"
            @onDelete="() => onForbidden(record)"
          />
          <a-divider
            v-if=" record.fdd_exist_sign === 1"
            type="vertical"
          />
		  <a
		    href="javascript:;"
		    @click="() => set(record)"
		  >设置</a>
		  <a-divider
		    v-if=" record.fdd_exist_sign === 1"
		    type="vertical"
		  />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <area-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :visible="areaVisible"
      :title="title"
      @onCancel="onCancelArea"
      @handleSubmit="handleSubmitArea"
    />
	<el-dialog
	  title="设置"
	  :visible.sync="dialogVisible"
	  width="30%"
	  >
	  <div>
		  <el-form ref="form" :model="form" label-width="140px">
		    <el-form-item label="推广人姓名脱敏" required>
		      <el-radio-group v-model="form.promoter_hidden">
		        <el-radio label="1">脱敏</el-radio>
		        <el-radio label="0">全名</el-radio>
		      </el-radio-group>
		    </el-form-item>
			<el-form-item label="医生姓名脱敏" required>
			  <el-radio-group v-model="form.doctor_hidden">
			  <el-radio label="1">脱敏</el-radio>
			  <el-radio label="0">全名</el-radio>
			  </el-radio-group>
			</el-form-item>
      <el-form-item label="签到图水印" required>
			  <el-radio-group v-model="form.sign_water">
			  <el-radio label="1">开启</el-radio>
			  <el-radio label="0">关闭</el-radio>
			  </el-radio-group>
			</el-form-item>
		  </el-form>
	  </div>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="dialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="setsave">确 定</el-button>
	  </span>
	</el-dialog>
  </div>
</template>
<script>
import { columns } from './data/index';
import AreaModal from './modal/index';
export default {
  components: {AreaModal},
  data() {
    return {
		form:{
      promoter_hidden:'',
      doctor_hidden: '',
      sign_water: ''
    },
		dialogVisible:false,
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      businessVisible: false,
      shopSystemVisible: false,
      title: '',
      checkKeyProp: 0,
      areaVisible: false,
      btnIsLoading: false,
      areaId: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({ type: 0, page: this.current, pageSize: this.pageSize });
  },
  methods: {
	 async set(record){
		 let result = await this.$http.post('/company/getConfig',  {id:record.id});
		 if (result.data.status === 1) {
			 this.form=result.data.data
		 	this.form.id=record.id
		 	this.dialogVisible=true
		 }
		
	  },
	 async setsave(){
		   let result = await this.$http.post('/company/setConfig',  this.form);
		   if (result.data.status === 1) {
		  		 this.dialogVisible=false
		   }
	  },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/company/getCompanyList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = params.page;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            companyInfoId: item.info_id,
            status: item.status,
            fdd_exist_sign: item.companyInfo.fdd_exist_sign,
            qichachaname: item.team_name?item.team_name:item.companyInfo.qichacha_name,
            contact: item.companyInfo.qichacha_oper_name,
            phone: item.companyInfo.phone,
            location: item.companyInfo.location,
            createtime: this.$Format(item.companyInfo.create_time),
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 新增大区账户
    addEditArea(record){
      this.areaVisible=true;
      this.title='新增大区';
      this.$nextTick(()=>{
        this.$refs.formRef.$refs.basicForm.form.resetFields();
      });
    },
    // 确认新增大区账户
    handleSubmitArea() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('TCL: handleSubmit -> values', values);
          if (!err) {
            this.btnIsLoading=true;
            values.icon=values.icon[0].uid;
            let result = await this.$http.post(
              '/company/append',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.areaVisible = false;
              this.getTableData({ type: 0, page: this.current, pageSize: this.pageSize });
            }
          }
        },
      );
    },
    // 取消新增大区账户
    onCancelArea() {
      this.areaVisible = false;
    },
    // 编辑或新增
    editAndAdd(record) {
      if (record.id) {
        this.$router.push({ path: '/business/edit', query: { id: record.id } });
      } else {
        this.$router.push('/business/add');
      }
    },
    // 取消编辑或新增
    onCancel() {
      this.businessVisible = false;
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post('/company/setStatus', {
        id: record.id,
        status: -1,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({
          type: 0,
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 签章
    async handleSignature(record){
      let result = await this.$http.post('/company/fddMakeSign', {
        companyInfoId: record.companyInfoId,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({
          type: 0,
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 禁用 启用
    async onForbidden(record) {
      let result = await this.$http.post('/company/setStatus', {
        id: record.id,
        status: record.status === 0 ? 1 : 0,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({
          type: 0,
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 分页
    changePage(pagination) {
      this.getTableData({
        type: 0,
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
  },
};
</script>
<style>
	.el-dialog__header {
	  border-bottom: 1px solid #eee;
	}																			
</style>
<style lang="scss" scoped>
.client-container {
}


</style>
